;(function($, undefined){

    'use strict';

    var rnn = window.rnn;

    function atAGlanceGallery(gallery, data, height, width){
        // Load theme
        Galleria.loadTheme(rnn.site.mediaURL + 'rnn/base/js/galleria-templates/ataglance/galleria.ataglance.js');
        Galleria.configure({
            height: height,
            responsive: true,
            dataSource: data,
            debug: false,
            onLastShow: '.controls.next',
            onFirstShow: '.controls.prev',
            imagePosition: 'top',
            extend: function () {
                this.bind('image', function (e) {
                    $('.controls.showTease:not(.active)').removeClass('showTease');
                });
            }
        });

        Galleria.run(gallery);
    }

    function buildGallery(gallery, data, height, width, hideCarousel){
        // Load theme
        Galleria.loadTheme(rnn.site.mediaURL + 'bower_components/galleria/themes/classic/galleria.classic.min.js');

        var gallery1 = $(gallery);
        // set these for desktop only.
        if (rnn.site.isDesktop === true) {
            $(gallery).css('width', width);
            $(gallery).css('height', height);
            height = $(gallery).css('height', height);
        } else {
            height = 1;
        }

        var carousel = 'lazy';
        if (hideCarousel === true) {
            carousel = false;
        }

        Galleria.configure({
            height: height,
            thumbnails: carousel,
            responsive: true,
            imagePosition: 'top',
            extend: function(){
                data = this._data;
                gallery = this._target;

                setTimeout(function(){
                    if($(gallery).find('.galleria-images img').length === 0){
                        $(gallery).find('.galleria-stage .galleria-images').html('<p>Gallery images not available at this time.</p>');
                        $(gallery).find('.galleria-loader').hide();
                        $(gallery).find('.galleria-counter').hide();
                        $(gallery).find('.galleria-image-nav').hide();
                    }
                }, 12000);

                // build custom interactions
                window.rnn.modules.galleryInteractions.buildInteractions(gallery, data);
            }
        });

        Galleria.run(gallery, {
            dataSource: data,
            transition: 'fade',
            debug: false,
            imageCrop: false,
            thumbCrop: true,
            fullscreenTransition: 'slide',
            imageTimeout: 12000
        });
        
        Galleria.ready(function(options) {
            this.lazyLoadChunks(9,0);
        });
    }

    function initAtAGlanceGallery() {
        var $galleries = $('.newsEntryGlance *[data-gallery]');

        if ($galleries.length) {
            $galleries.each(function() {
                var $this = $(this),
                    height = $this.data('gallery').height,
                    width = $this.data('gallery').width,
                    data = $this.data('gallery').dataSource;

                if (rnn.site.isMobile === true) {
                    height = 0.75;
                }

                $.ajax({
                    url: data,
                    dataType: 'json',
                    crossDomain: false,
                    success: function(data){
                        atAGlanceGallery($this[0], data, height, width);
                    }
                });
            });
        }
    }

    function initGalleries(){
        var $galleries = $('*[data-gallery]');

        if ($galleries.length === 1) {
            // we dont want history for bss
            if (!$galleries.data('gallery').disableHistory) {
                var historyPlugin = document.createElement('script');
                historyPlugin.src = rnn.site.mediaURL + 'bower_components/galleria/plugins/history/galleria.history.min.js';
                document.getElementsByTagName('head')[0].appendChild(historyPlugin);
            }
        }

        if ($galleries.length) {
            $galleries.each(function() {
                var $this = $(this),
                    galleryData = $this.data('gallery'),
                    width = galleryData.width,
                    hideCarousel = $this.data('hidecarousel'),
                    dataUrl = $this.data('gallery').dataSource;

                var height = galleryData.height;

                if (galleryData.heightMobile && window.innerWidth < 767){
                    height = galleryData.heightMobile;
                }

                if (galleryData.type === 'inlineEmbed') {
                    var $article = $this.closest('.newsEntry'),
                        articleData = $article.data('gallery-config');

                    if (!_.isUndefined(articleData)) {
                        height = articleData.height;
                        width = articleData.width;
                    }
                }

                //Use 1880px wide image for larger gallery
                if (width == 940)
                    dataUrl += '?image_width=1880';

                if ($this.data('json-gallery') && $this.data('json-gallery').length > 0) {
                    buildGallery(this, $this.data('json-gallery'), height, width, hideCarousel);
                }else{
                    $.ajax({
                        url: dataUrl,
                        dataType: 'json',
                        crossDomain: false,
                        success: function(data){
                            buildGallery($this[0], data, height, width, hideCarousel);
                        }
                    });
                }
            });
        }
    }

    rnn.modules.register('galleries', {
        init: initGalleries,
        initAtAGlanceGallery: initAtAGlanceGallery
    });

})(jQuery);